export const formatNumberToMillionSystem = (num, decimalCount) => {
  if (!num?.toString()) return "";
  const numParts = num?.toString().split(".");
  const integerPart = numParts[0];
  let decimalPart = numParts[1];

  if (decimalCount) {
    decimalPart = decimalPart || 0;
    decimalPart = decimalPart?.toString()?.padEnd(decimalCount, "0")?.slice(0, 4);
  }

  return [Number(integerPart).toLocaleString(), decimalPart].filter(Boolean).join(".");
};

export const getJsonFromString = (string) => {
  if (!string || typeof string !== "string" || string.trim() === "") {
    return false;
  }

  let input = string.trim();

  try {
    // Attempt to parse directly as JSON first for strict JSON strings
    const parsedJson = JSON.parse(input);
    return parsedJson;
  } catch (jsonError) {
    // If direct JSON parsing fails, try to convert from a JS object literal format
    let str = input;

    // Convert single quotes to double quotes
    str = str.replace(/'/g, '"');

    // Quote unquoted keys: { key: value } -> { "key": value }
    // This regex handles keys that are valid JS identifiers
    str = str.replace(/([{,]\s*)([a-zA-Z_$][a-zA-Z0-9_$]*)\s*:/g, '$1"$2":');

    // Quote unquoted string values that are not numbers, booleans, or null
    // This regex looks for patterns like `: value` where value is an unquoted string
    // and wraps it in double quotes. It avoids quoting numbers, true, false, null.
    str = str.replace(/:(\s*)([a-zA-Z0-9_$-]+)(?=[,\}\]])/g, (match, p1, p2) => {
      // Check if the value is a number, boolean, or null
      if (
        !isNaN(p2) ||
        p2 === "true" ||
        p2 === "false" ||
        p2 === "null"
      ) {
        return `:${p1}${p2}`; // Don't quote if it's a number, boolean, or null
      }
      return `:${p1}"${p2}"`; // Quote the string value
    });


    // Remove trailing commas: { "a": 1, } -> { "a": 1 }
    str = str.replace(/,\s*([}\]])/g, '$1');

    // Attempt to parse the modified string as JSON
    try {
      const parsedJson = JSON.parse(str);
      return parsedJson;
    } catch (conversionError) {
      // If even after conversion it's not valid JSON, it's not a valid JS object literal for this purpose
      return false;
    }
  }
};
